<ng-container *ngIf="team">
  <div class="pagewrapper">
    <div class="teaser" *ngIf="canManagePlanAndFunding && !this.team.role && team.plan === freePlan">
      <img class="teaserimage" src="assets/graphics/getting_started.png" />
      <div class="teaserright">
        <span
          >Want even more <span class="bold">choice</span> and
          <span class="bold">control?</span></span
        >
        <span class="link" (click)="changePlan()">Upgrade to the Plus plan</span>
      </div>
    </div>
    <div class="editsection">
      <span><span class="listitem">1. Wellspace: </span>{{ ' ' + team.name }}</span>
      <button mat-button shape="" class="editbutton" (click)="editName()">Edit</button>
    </div>
    <div class="editsection">
      <div class="center-toggle-content">
        <mat-slide-toggle
          #reimbursementsToggle
          [checked]="!team?.disabled"
          (change)="enabledChanged($event)"
        >
          Allow reimbursements
        </mat-slide-toggle>
        <mat-spinner
          class="team-edit-toggle-spinner"
          [color]="'accent'"
          [diameter]="20"
          *ngIf="showReimbursementsSpinner"
        ></mat-spinner>
      </div>
    </div>
    <div class="editsection">
      <div class="center-toggle-content">
        <mat-slide-toggle
          #monthlyAllowanceToggle
          [checked]="!team?.topupDisabled"
          (change)="topupEnabledChanged($event)"
        >
          Enable monthly allowance
        </mat-slide-toggle>
        <mat-spinner
          class="team-edit-toggle-spinner"
          [color]="'accent'"
          [diameter]="20"
          *ngIf="showMonthlyAllowanceSpinner"
        ></mat-spinner>
      </div>
    </div>
    <div class="editsection">
      <span><span class="listitem">2. Benefits:</span></span>
      <button mat-button shape="" class="editbutton" (click)="editCategories()">Edit</button>
    </div>
    <span class="editsection">Reimbursement Categories: {{ team.categories.length }}</span>
    <div class="categories">
      <mat-chip-set>
        <mat-chip *ngFor="let category of categories">
          <div class="chipinfo">
            <span>{{ category.category }}</span>
            <span class="taxable" *ngIf="category.taxable">Taxable</span>
          </div>
        </mat-chip>
      </mat-chip-set>
    </div>
    <div class="excluded-transactions">
      <mat-form-field appearance="outline" class="excluded-transactions-field">
        <mat-label>Excluded transactions</mat-label>
        <mat-chip-grid #excludedTransactionChipGrid aria-label="Excluded transactions">
          <mat-chip-row
            *ngFor="let term of excludedTransactionTerms; trackBy: trackExcludedTransactionTerm"
            [removable]="!isExcludedTransactionsSaving"
            (removed)="removeExcludedTransactionTerm(term)"
          >
            {{ term }}
            <button
              matChipRemove
              type="button"
              [disabled]="isExcludedTransactionsSaving"
              [attr.aria-label]="'Remove ' + term"
            >
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
          <input
            placeholder="amazon prime"
            [disabled]="isExcludedTransactionsSaving"
            [matChipInputFor]="excludedTransactionChipGrid"
            [matChipInputSeparatorKeyCodes]="excludedTransactionSeparatorKeysCodes"
            [matChipInputAddOnBlur]="true"
            (matChipInputTokenEnd)="addExcludedTransactionTerm($event)"
            matInput
          />
        </mat-chip-grid>
      </mat-form-field>
      <div class="excluded-transactions-helper">
        Transactions whose description contains one of these phrases will not be reimbursed for this team.
      </div>
      <div class="excluded-transactions-warning" *ngIf="broadExcludedTransactionTerms.length">
        <mat-icon>warning_amber</mat-icon>
        <span>
          Broad exclusions such as {{ broadExcludedTransactionTerms.join(', ') }} can hide unrelated eligible transactions.
        </span>
      </div>
    </div>
    <div class="excluded-transactions">
      <mat-form-field appearance="outline" class="excluded-transactions-field">
        <mat-label>Included transactions</mat-label>
        <mat-chip-grid #includedTransactionChipGrid aria-label="Included transactions">
          <mat-chip-row
            *ngFor="let term of includedTransactionTerms; trackBy: trackIncludedTransactionTerm"
            [removable]="!isIncludedTransactionsSaving"
            (removed)="removeIncludedTransactionTerm(term)"
          >
            {{ term }}
            <button
              matChipRemove
              type="button"
              [disabled]="isIncludedTransactionsSaving"
              [attr.aria-label]="'Remove ' + term"
            >
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
          <input
            placeholder="uber"
            [disabled]="isIncludedTransactionsSaving"
            [matChipInputFor]="includedTransactionChipGrid"
            [matChipInputSeparatorKeyCodes]="includedTransactionSeparatorKeysCodes"
            [matChipInputAddOnBlur]="true"
            (matChipInputTokenEnd)="addIncludedTransactionTerm($event)"
            matInput
          />
        </mat-chip-grid>
      </mat-form-field>
      <div class="excluded-transactions-helper">
        Transactions whose description contains one of these phrases will be considered reimbursable for this team.
      </div>
    </div>
    <app-monthly-topup-schedule *ngIf="team?.approved" [teamId]="team.id"></app-monthly-topup-schedule>
    <span class="editsection">Monthly allowance amount: ${{ team.amount.toFixed(2) }}</span>
    <div *ngIf="!this.team.role" class="paymentsection">
      <span class="editsection">Plan: {{ this.team.plan }}</span>
      <span *ngIf="canManagePlanAndFunding" class="linkbutton" (click)="changePlan()">Change Plan</span>
    </div>
    <div *ngIf="this.team.role" class="paymentsection">
      <span class="editsection" *ngIf="!paymentMethod">Funding Method:</span>
      <span class="linkbutton"
        >You are a delegated admin so you can't change the funding method. Only team owners can change
        the funding method.</span
      >
    </div>
    <div *ngIf="!this.team.role && !paymentMethod" class="paymentsection">
      <span class="editsection">Funding Method: None</span>
      <span *ngIf="canManagePlanAndFunding" class="linkbutton" (click)="addPaymentMethod()">Add funding method</span>
    </div>
    <div *ngIf="!this.team.role && paymentMethod" class="paymentsection">
      <span class="editsection"
        >Default Funding Method: {{ paymentMethod.bankInfo.bankName }} ****{{
          paymentMethod.stripeLast4
        }}</span
      >
      <span *ngIf="canManagePlanAndFunding" class="linkbutton" (click)="changePaymentMethod()"
        >Change funding method/View charge history</span
      >
    </div>
    <div class="editsection">
      <span>
        <span class="listitem">3. Team Members: </span>
        <span *ngIf="membersLoading">Loading...</span>
        <span *ngIf="!membersLoading && membersLoadError">Unable to load members</span>
        <span *ngIf="!membersLoading && !membersLoadError">{{ members.length }}</span>
      </span>
      <button mat-button shape="" class="editbutton" [disabled]="membersLoading || membersLoadError" (click)="editMembers()">Edit</button>
    </div>
    <div
      *ngIf="canShowMemberFundingWarning"
    >
      <div class="warningbox" *ngIf="newMembers.length && !this.team.role">
        <span>
          You have set allowances for
          <span style="font-weight: bold"
            >{{ newMembers.length }} member{{ newMembers.length > 1 ? 's' : '' }} that you need to
            fund</span
          >
          before they can start receiving a monthly allowance.
        </span>
        <span *ngIf="newMembers.length && !paymentMethod && !this.team.role && canManagePlanAndFunding"
          >But first, you need to
        </span>
        <span
          *ngIf="newMembers.length && !paymentMethod && !this.team.role && canManagePlanAndFunding"
          class="linkbutton"
          (click)="addPaymentMethod()"
          >add a funding method.</span
        >
      </div>
      <div
        *ngIf="
          team.amount > 0 &&
          newMembers.length &&
          paymentMethod &&
          !paymentMethod?.bankInfo?.isPending
        "
        class="funding-member-btn-container"
      >
        <div class="funding-member-btn-container-inner">
          <button
            mat-raised-button
            class="donebutton"
            color="primary"
            [disabled]="monthlyTopupSchedule?.fundingBlocked"
            (click)="fundAllowancesClicked()"
          >
            Fund Member Allowances
          </button>
          <div class="center-toggle-content">
            <mat-slide-toggle
              #proRateFundingToggle
              [checked]="team.proRate && team.proRate === 0"
              (change)="proRateToggleChange($event)"
            >
              Start at next scheduled top-up
            </mat-slide-toggle>
          </div>
        </div>
        <app-card
          *ngIf="showWarnCard()"
          message="Do not forget to click on 'Fund Member Allowances' to set allowances to start on the next scheduled top-up."
          type="warning"
        ></app-card>
      </div>
    </div>
    <div *ngIf="team.amount === 0 && !paymentMethod?.bankInfo?.isPending" class="warningbox">
      <span
        >You have not yet set an allowance amount or benefits categories so you will only be able to
        send instant one-time rewards to team members.</span
      >
    </div>
    <div *ngIf="paymentMethod?.bankInfo?.isPending" class="warningbox">
      <span
        >The current payment method status is 'Pending'. To proceed, please select a verified payment
        method.</span
      >
    </div>
    <div class="list">
      <div class="invite-button">
        <app-send-invites-button
          [teamId]="getTeamId()"
          [pendingInvitesCount]="pendingInvitesCount"
          [hasPendingAutomation]="hasPendingInviteAutomation"
          (invitesSent)="loadTeamMembers()"
        ></app-send-invites-button>
      </div>
      <div class="card" *ngFor="let member of members">
        <app-user-item
          (memberChangedEvent)="loadTeamMembers()"
          class="useritem"
          [showHeader]="member === members[0]"
          [team]="team"
          [wallitBalance]="isAdmin"
          [member]="member"
          [detail]="true"
        ></app-user-item>
      </div>
      <span class="nomembers" *ngIf="members && members.length === 0">No team members</span>
    </div>
    <span class="approvalwarning" *ngIf="!team.approved"
      >Your team is awaiting approval by Wallit.</span
    >
    <span class="questions">Have questions about your wellspace?</span>
    <span class="questions"
      >Drop us a note at <a class="link" href="mailto:help@wallit.app">help&#64;wallit.app</a></span
    >
    <div class="buttons">
      <button
        mat-raised-button
        *ngIf="team.amount === 0 && newMembers.length && paymentMethod"
        class="donebutton"
        color="primary"
        (click)="sendEmailsClicked()"
      >
        Invite Team Members
      </button>
      <button
        [disabled]="!team.approved"
        mat-raised-button
        *ngIf="team && canSendOneTimeRewards()"
        class="donebutton"
        color="primary"
        (click)="sendOnetimeClicked()"
      >
        One Time Reward
      </button>
      <button
        [disabled]="!team.approved"
        mat-raised-button
        *ngIf="team && paymentMethod && !paymentMethod?.bankInfo?.isPending"
        class="donebutton"
        color="primary"
        (click)="uploadRewardsClicked()"
      >
        Upload Rewards
      </button>
      <button
        [disabled]="!team.approved"
        mat-raised-button
        *ngIf="team && paymentMethod && !paymentMethod?.bankInfo?.isPending"
        class="donebutton"
        color="primary"
        (click)="sendOnetimeP2pClicked()"
      >
        Member-to-Member Top Up
      </button>
      <button
        mat-raised-button
        *ngIf="team"
        class="donebutton"
        color="warn"
        (click)="deleteClicked()"
      >
        Delete Wellspace
      </button>
    </div>
  </div>
</ng-container>
